<script lang="ts">
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import TableEntry from "$form/Fields/Shared/TableEntry.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import { createEventDispatcher, onMount, getContext } from "svelte";
	import type { t as tBase } from "$lib/helpers/translate";

	export let field: FieldDisplay & { type: "TableEntry" };
	export let value: TableEntryValue;

	const t = getContext<typeof tBase>("t");

	let inputRef: HTMLDivElement;
	let focused = false;

	const dispatch = createEventDispatcher();
	onMount(() => {
		inputRef.addEventListener("focusin", () => {
			if (focused) return;
			focused = true;
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("focusout", () => {
			requestAnimationFrame(() => {
				const hasFocus = Array.from(
					inputRef.querySelectorAll("input, select, button")
				).some((input) => input === document.activeElement);
				if (!hasFocus) {
					focused = false;
					dispatch("updateOther", {
						tainted: true
					});
					dispatch("updateOther", {
						active: false
					});
				}
			});
		});
	});
</script>

<div class="field-label-cover">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		<Label html="{field.labelHTMLComputed}" />
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<TableEntry
		rows="{field.settings.default || '3'}"
		max="{field.settings.max}"
		headers="{field.settings.columns}"
		bind:value="{value}"
		bind:element="{inputRef}"
		add_row_text="{t.get('add_row')}" />
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
